import { useEffect, useState, useContext, createContext } from 'react'
import styled from 'styled-components'
import { isEmpty, request } from '@navinc/utils'
import { PageContainer, StandardCard, useToast } from '@navinc/base-react-components'
import { Loader } from '../../../components/loader'
import { usePartner } from '../../../hooks/apollo/use-partner'
import { getToken } from '../../../../utils/tokens'

const StyledPageContainer = styled(PageContainer)`
  & > ${StandardCard} {
    width: 100%;
  }
`

const BillingStatusContext = createContext({})

// eslint-disable-next-line import/no-unused-modules
export const useBillingStatus = () => {
  const billingStatus = useContext(BillingStatusContext)

  return billingStatus
}

export const BillingStatusProvider = ({ children }) => {
  const [, setError] = useState(null)
  const [data, setData] = useState({})
  // Ultimately this will come from capabilities

  const { getFormattedCustomerSupportPhone, getIsPartnerSeek } = usePartner()
  const customerSupportPhone = getFormattedCustomerSupportPhone()
  const isPartnerBillable = getIsPartnerSeek()

  const [isLoading, setIsLoading] = useState(isPartnerBillable)

  const { showMessage } = useToast()

  useEffect(() => {
    if (!isPartnerBillable) return
    setIsLoading(true)
    request({
      url: `/ent-api/api/authentication/billing/status`,
      headers: {
        authorization: `Token ${getToken()}`,
      },
    })
      .then(({ data }) => {
        setData(data)
        return data
      })
      .then(() => setIsLoading(false))
      .catch(({ body = {}, status, data = {} }) => {
        const errors = data.errors || body.errors || []
        const error = {
          errors,
          status,
        }
        setError(error)
        showMessage({
          copy: `Please call our customer support team at ${customerSupportPhone}, 7am - 5pm MST, Monday - Friday.`,
          shouldNotTimeout: true,
          title: 'Something went wrong fetching your billing info.',
          type: 'error',
        })
        return Promise.reject(error)
      })
      .catch(() => setIsLoading(false))
  }, [customerSupportPhone, isPartnerBillable, showMessage])

  const { isActive, isDunning, isCancelled = !isActive } = data

  const needsToRedirectToBilling = isPartnerBillable && !isEmpty(data) && (isCancelled || isDunning) && !isLoading

  useEffect(() => {
    if (needsToRedirectToBilling) window.location.assign('/partner/registration/plan?cancelled=true')
  }, [needsToRedirectToBilling])

  return (
    <BillingStatusContext.Provider value={{ isLoading, ...data }}>
      {!isPartnerBillable || (!isLoading && !needsToRedirectToBilling) ? (
        children
      ) : (
        <StyledPageContainer>
          <Loader />
        </StyledPageContainer>
      )}
    </BillingStatusContext.Provider>
  )
}
